import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { SocketService } from '../../services/socket.service';



@Component({
	selector: 'app-qr',
	templateUrl: './qr.component.html',
	styleUrls: ['./qr.component.scss']
})


export class QrComponent implements OnInit {

	//------------------------------------------------------------------- CONSTRUCTOR
	constructor(
		private socketService: SocketService,
	) { }

	//------------------------------------------------------------------- INIT
	ngOnInit() {
	
	}

	//------------------------------------------------------------------- DESTROY
	ngOnDestroy() {

	}

}



// WEBPACK FOOTER //
// /app/src/app/views/qr/qr.component.ts